import styled, { css, FlattenSimpleInterpolation } from "styled-components";

const PersonaContainerViews: { [key: string]: FlattenSimpleInterpolation } = {
  mobile: css`
    display: flex;
    flex: 1 1 auto;
    width: 100%;
  `,
  tablet: css`
    display: flex;
    flex: 1 1 auto;
    width: 100%;
  `,
  tabletLandscape: css`
    display: flex;
    flex: 1 1 auto;
    width: 100%;
  `,

  browser: css`
    width: 100%;
    height: 100%;
    z-index: 0;
  `,
};

export const PersonaContainerStyle = styled.div`
  ${(props: { deviceType: string; isLandscape: boolean }) => {
    switch (props.deviceType) {
      case "mobile":
        return PersonaContainerViews["mobile"];
      case "tablet":
        return props.isLandscape
          ? PersonaContainerViews["tabletLandscape"]
          : PersonaContainerViews["tablet"];

      case "browser":
        return PersonaContainerViews["browser"];
    }
  }}
`;
